module.exports = __webpack_public_path__ + "static/img/GT.ff603e98.svg";